export default {
    services: {
      portal: {
        available: true,
        superuser: true,
      },
      maps: {
        available: false,
        superuser: true,
      },
      geocontrib: {
        available: false,
        superuser: true,
      },
      stats: {
        available: false,
        superuser: false,
      },
      geoserver: {
        available: false,
        superuser: true,
      },
      geonetwork: {
        available: false,
        superuser: true,
      },
    },
    components: {
      QualityLabel: 'dataset-detail-top-anchor',
    },
    itemsPerPage: {
      datasets: 20,
      jurisdictions: 20
    },
    logs: {
      itemsPerPage: 50,
    },
    forms: {
      user: {
        hiddenFields: [],
        requiredFields: [
          'last_name',
          'first_name',
          'email',
        ]
      },
      organisation: {
        hiddenFields: [],
        requiredFields: [
          'display_name',
          'organisation_type',
        ]
      },
      group: {
        hiddenFields: [],
        requiredFields: [
          'name',
        ]
      },
      sphere: {
        hiddenFields: [],
        requiredFields: [
          'name',
        ]
      },
      contact: {
        hiddenFields: [],
        requiredFields: [
          'name',
          'email',
        ]
      },
      dataset: {
        hiddenFields: [],
        extraFields: [],
        requiredFields: [
          'display_name',
          'description',
          'keywords',
          'topics',
          'kinds',
          'usergroup',
          'publication_date',
          'last_update_date',
          'update_frequency',
        ]
      },
      resource: {
        datastore: {
          superuserOnly: false,
          hiddenFields: [],
          requiredFields: [
            'display_name',
          ]
        },
        'file-upload': {
          superuserOnly: false,
          hiddenFields: [],
          requiredFields: [
            'display_name',
            'column_x',
            'column_y',
            'crs'
          ]
        },
        ftp: {
          superuserOnly: true,
          hiddenFields: [],
          requiredFields: [
            'display_name',
            'column_x',
            'column_y',
            'crs'
          ]
        },
        'file-download': {
          superuserOnly: false,
          hiddenFields: [],
          requiredFields: [
            'display_name',
            'column_x',
            'column_y',
            'crs'
          ]
        },
        href: {
          superuserOnly: false,
          hiddenFields: [],
          requiredFields: [
            'display_name',
          ]
        },
        geoserver: {
          superuserOnly: false,
          hiddenFields: [],
          requiredFields: [
            'display_name',
          ],
        },
      },
      indexer: {
        hiddenFields: [],
        requiredFields: [
          'name',
          'url',
          'command',
          'scheduler',
        ]
      },
    },
    resourceTypes: [
      'file-upload',
      'ftp',
      'href',
      'geoserver'
    ],
    annexTypes: [
      'file-upload',
      'ftp',
      'href',
    ]
  };
